module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzBkYjAyYiIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg1MTJ2MzQxLjMzM0gweiIvPgogIDxwYXRoIGZpbGw9IiNlMDUyMDYiIGQ9Ik0wIDBoNTEydjE3MC42NjdIMHoiLz4KICA8Y2lyY2xlIGN4PSIyNTYiIGN5PSIyNTYiIHI9IjcyLjUzMyIgZmlsbD0iI2UwNTIwNiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ne.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ne.svg
// module chunks = 0